import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Phone: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 0.5C7.38805 0.5 6.5614 0.84241 5.9519 1.4519C5.34241 2.0614 5 2.88805 5 3.75V20.25C5 21.112 5.34241 21.9386 5.9519 22.5481C6.5614 23.1576 7.38805 23.5 8.25 23.5H15.75C16.612 23.5 17.4386 23.1576 18.0481 22.5481C18.6576 21.9386 19 21.112 19 20.25V3.75C19 2.88805 18.6576 2.0614 18.0481 1.4519C17.4386 0.84241 16.612 0.5 15.75 0.5H8.25ZM8.25 2.5C7.91848 2.5 7.60054 2.6317 7.36612 2.86612C7.1317 3.10054 7 3.41848 7 3.75V20.25C7 20.5815 7.1317 20.8995 7.36612 21.1339C7.60054 21.3683 7.91848 21.5 8.25 21.5H15.75C16.0815 21.5 16.3995 21.3683 16.6339 21.1339C16.8683 20.8995 17 20.5815 17 20.25V3.75C17 3.41848 16.8683 3.10054 16.6339 2.86612C16.3995 2.6317 16.0815 2.5 15.75 2.5H14.5H9.5H8.25Z"
        fill="currentColor"
      />

      <path
        d="M10.5 19.25C9.94772 19.25 9.5 19.6977 9.5 20.25C9.5 20.8023 9.94772 21.25 10.5 21.25H13.5C14.0523 21.25 14.5 20.8023 14.5 20.25C14.5 19.6977 14.0523 19.25 13.5 19.25H10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Phone;
